import React, { Component } from 'react'
import AuthUserContext from '../auth/session/context';
import { Link } from 'react-router-dom';
import styles from '../css/Landing.module.css';

export default class LandingPage extends Component {
    render() {
        return (
            <>
                <h1>Helps you gain insight into the UX of your product</h1>
                <div className={styles.module}>
                    <div className={styles.users}>
                        <div className={styles.usersIcon}></div>
                        <p>Don't miss out on knowing your users</p>
                    </div>
                    <div className={styles.experiment}>
                        <div className={styles.experimentIcon}></div>
                        <p>Experiment with your product</p>
                    </div>
                    <div className={styles.measure}>
                        <div className={styles.measureIcon}></div>
                        <p>Measure the experience</p>
                    </div>
                    <div className={styles.overview}>
                        <div className={styles.overviewIcon}></div>
                        <p>See what your users really think</p>
                    </div>
                </div>
            </>
        )
    }
}
